<template>
  <div class="query-panel">
    <el-form :model="queryParam" label-position="right" label-width="100px" size="small" class="query-form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="订单编号">
            <el-input v-model="queryParam.orderNumber" class="panel-input" />
          </el-form-item>
        </el-col>
        <!-- <el-col v-if="showSubOrderCondition" :span="8">
          <el-form-item label="子订单编号">
            <el-input v-model="queryParam.subOrderNumber" class="panel-input" />
          </el-form-item>
        </el-col> -->
        <span v-if="!showSubOrderCondition">
          <el-col :span="8">
            <el-form-item label="收货人姓名">
              <el-input v-model="queryParam.receivePerson" class="panel-input" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货人手机号">
              <el-input v-model="queryParam.receivePhone" class="panel-input" />
            </el-form-item>
          </el-col>
        </span>
        <el-col :span="8" v-if="showSubOrderCondition">
          <el-form-item label="物料名称">
            <el-input v-model="queryParam.itemName" class="panel-input" />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="orderType !== 'shopSign'">
          <el-form-item label="订单状态">
            <el-select v-model="queryParam.orderStatus" placeholder="订单状态" clearable>
              <el-option
                v-for="option in showOrderStatusList"
                :key="option.key"
                :label="option.value"
                :value="option.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应商名称">
            <el-input v-model="queryParam.supplierName" class="panel-input" />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="订单日期">
            <el-col :span="11">
              <el-date-picker
                v-model="queryParam.orderDateFrom"
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd"
                class="form-date-item"
                @change="startTimeStatus"
                :picker-options="pickerOptionsStart"
              />
            </el-col>
            <el-col class="text-center" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="queryParam.orderDateTo"
                type="date"
                placeholder="截止日期"
                value-format="yyyy-MM-dd"
                class="form-date-item"
                @change="endTimeStatus"
                :picker-options="pickerOptionsEnd"
              />
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="7" v-if="showSubOrderCondition">
          <el-input
            placeholder="关键字搜索"
            v-model="queryParam.keyword"
            class="panel-input"
            style="margin-left: 53px"
            size="small">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-col>
        <span v-if="orderType === 'shopSign'">
          <!-- <span v-if="false"> -->
          <el-col :span="8">
            <el-form-item label="trade提报单号">
              <el-input
                v-model="queryParam.tradeApplyNumber"
                class="panel-input"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="售点名称">
              <el-input v-model="queryParam.pocName" class="panel-input" />
            </el-form-item>
          </el-col>
        </span>
      </el-row>
    </el-form>
    <div class="btn-line">
      <el-button class="btn-blue-plain" @click="doQuery" size="small">查询订单</el-button>
      <el-button class="btn-grey-plain" @click="resetQuery" size="small">重置</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'order-query-panel',
  props: {
    orderType: {
      type: String,
      default: 'menu'
    }
  },
  data () {
    return {
      queryParam: {
        orderNumber: '',
        subOrderNumber: '',
        itemName: '',
        orderStatus: '',
        orderDateFrom: '',
        orderDateTo: '',
        keyword: '',
        receivePerson: '',
        receivePhone: '',
        supplierName: '',
        tradeApplyNumber: '',
        pocName: ''
      },
      pickerOptionsStart: {},
      pickerOptionsEnd: {}
    }
  },
  computed: {
    ...mapState({
      orderStatusList: state => state.base.purchaseOrderStatusMap,
      orderPrintStatusList: state => state.base.purchaseOrderStatusMap,
      freezerOrderStatusList: state => state.base.quotaOrderStatusMap
    }),
    showSubOrderCondition () {
      return this.orderType !== 'freezer'
    },
    showOrderStatusList () {
      switch (this.orderType) {
        case 'menu':
          return this.orderStatusList
        case 'non-menu':
          return this.orderStatusList
        case 'printing':
          return this.orderPrintStatusList
        case 'freezer':
          return this.freezerOrderStatusList
        default:
          return []
      }
    }
  },
  created () {
    this.$store.dispatch('getDictByName', 'purchaseOrderStatusMap')
    this.$store.dispatch('getDictByName', 'purchaseOrderStatusMap')
    this.$store.dispatch('getDictByName', 'quotaOrderStatusMap')
  },
  methods: {
    doQuery () {
      this.$emit('search', this.queryParam)
    },
    resetQuery () {
      this.queryParam = {
        orderNumber: '',
        subOrderNumber: '',
        itemName: '',
        orderStatus: '',
        orderDateFrom: '',
        orderDateTo: '',
        keyword: '',
        receivePerson: '',
        receivePhone: '',
        supplierName: '',
        tradeApplyNumber: '',
        pocName: ''
      }
      this.doQuery()
    },
    // 时间开始选择器
    startTimeStatus: function (value) {
      this.pickerOptionsEnd = {
        disabledDate: time => {
          let beginDateVal = this.queryParam.orderDateFrom
          if (beginDateVal) {
            return (
              time.getTime() <= new Date(beginDateVal).getTime() - 86400000
            )
          }
        }
      }
    },
    // 时间结束选择器
    endTimeStatus: function (value) {
      this.pickerOptionsStart = {
        disabledDate: time => {
          let endDateVal = this.queryParam.orderDateTo
          if (endDateVal) {
            return time.getTime() >= new Date(endDateVal).getTime()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.query-panel {
  border-radius: 10px;
  padding: 20px 30px 10px 30px;
  background-color: $base-white;
  margin-bottom: 20px;

  .form-date-item {
    width: 100%;
  }

  .btn-line {
    text-align: center;
    padding: 15px;
  }

  .panel-input {
    width: 203px;
  }
}
</style>
